/* eslint-disable */
"use strict";
var config, service, xml7;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  xml7 = config.VUE_APP_MOL_S_XML7
}

async function creaXml7Fattura(documento) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${xml7}/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(documento),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    // errorService.onError(error, 'aggiornaDocumento')
  }
}

async function creaXml7Multipli(idsDocumenti) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    var data = {
      idsDocumenti,
    };
    const response = await fetch(`${service}/${xml7}/create/multipli`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    // errorService.onError(error, 'aggiornaDocumento')
  }
}

export default {
  creaXml7Fattura,
  creaXml7Multipli,
};
